// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5405":"21489d65","6452":"f24e6fb6","6850":"4147e914"}[chunkId] + ".chunk.css";
};